import { request, createSuccessCodeWithZero } from '../request'
const messageRequest = createSuccessCodeWithZero()

// 待我处理问卷分页查询
export function getMultiAuditSurvey(params) {
  return request({
    url: '/answer/multiAudit/survey/page',
    method: 'get',
    params
  })
}

// 获得各tab未审核总数及各tab页初始条件
export function getTotalCountMulti(surveyId, params) {
  return request({
    url: '/answer/multiAudit/qualityControl/getTotalCount/' + surveyId,
    method: 'get',
    params
  })
}

// 抽样数据---分页查询（多级审批专用）
export function getSamplingDataMulti(params) {
  return request({
    url: '/answer/multiAudit/qualityControl/page',
    method: 'get',
    params
  })
}
// 一键质控
export function auditBatchMulti(data) {
  return request({
    url: '/answer/multiAudit/auditBatch',
    method: 'post',
    data
  })
}

// 单项质控
export function auditOneMulti(data) {
  return request({
    url: '/answer/multiAudit/auditOne',
    method: 'post',
    data
  })
}

// 驳回 20200830
export function rejectQuestionMulti(data) {
  return request({
    url: '/answer/multiAudit/reject',
    method: 'post',
    data
  })
}

// 获得完整审批流
export function getFullTaskFlow(params) {
  return request({
    url: '/answer/multiAudit/fullTaskFlow',
    method: 'get',
    params
  })
}

// 批量审核
export function handleMultiAudit(data) {
  return request({
    url: '/answer/qualityControl/auditSelected',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 获取驳回、拒绝原因
export function getCause(params) {
  return request({
    url: '/answer/qualityControl/getCause',
    method: 'get',
    params
  })
}


// 通过id 批量审核
export function multiAuditByIds(ids, data) {
  return messageRequest.post("/answer/multiAudit/auditSelected", Object.assign({ ids }, data))
}